import Text from '@commons/components/Text';
import type { DrupalBlock, DrupalText } from '@commons/types/drupal';

/**
 * Site alerts title field block component.
 *
 * Set the margin bottom to avoid using a spacer inline block in the default layout.
 */

const SiteAlertsTitleFieldBlock = ({ content }: DrupalBlock<DrupalText>) => {
  if (!content.value) return null;

  return (
    <Text as="h1" level="h2" marginBottom="lg">
      {content.value}
    </Text>
  );
};

export default SiteAlertsTitleFieldBlock;
